<script setup lang="ts">
import type { ParsedFilterData } from '@autobid/strapi-integration/server/trpc/routers/auctions/auctionsFilter'
import type { Ref } from 'vue'
import { useAuctionStore } from '@autobid/nuxt-pinia-store/store/useAuctionStore'
import { Combobox } from '@headlessui/vue'
import { storeToRefs } from 'pinia'
import AuctionButtonsContainer from './AuctionButtonsContainer.vue'
import AuctionListFilterButton from './AuctionListFilterButton.vue'

const auctionStoreKey = inject('auctionStoreKey')
const { filter } = storeToRefs(useAuctionStore(String(auctionStoreKey)))

const filterData = inject<Ref<ParsedFilterData>>('filterData')

function toggleAll() {
  if (!filterData)
    return

  filter.value.appIds
    = filter.value.appIds.length === filterData.value.apps.length
      ? []
      : filterData.value.apps.map(({ id }) => id)
}
</script>

<template>
  <Combobox v-model="filter.appIds" multiple>
    <AuctionButtonsContainer>
      <AuctionListFilterButton as="button" @click="toggleAll">
        {{ $t('auction-list.all') }}
      </AuctionListFilterButton>
      <AuctionListFilterButton
        v-for="app in filterData?.apps"
        :key="app.id"
        :selected="filter.appIds.includes(app.id)"
        :value="app.id"
      >
        {{ app.name }}
      </AuctionListFilterButton>
    </AuctionButtonsContainer>
  </Combobox>
</template>
